export default __webpack_public_path__ + "static/media/Phoebe_9781843628231.ebb12c80.jpg";